import React from "react";
import SettingsHeader from "../../components/Profile/SettingsHeader";
import { GLOBAL_IMAGES } from "../asset";
import AboutContent from "../../components/about/AboutContent";

const About = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg_low_b})`,
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="min-h-screen bg-white font-mali"
    >
      <SettingsHeader name="About Us" oneBack="true" />
      <AboutContent />
    </div>
  );
};

export default About;
